import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { AgentUserQuery } from 'interfaceAdapter/queries/AgentUser';
import { agentUserContext } from 'application/contexts/useAgentUser';

/**
 * 認証状態の確認と、ログイン後ページの共通処理
 */
export const useAgentStandard = () => {
    const mainRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const agentUserQuery = diContainer.resolve(AgentUserQuery);
    const { user, setUser } = useContext(agentUserContext);
    const [canEnter, setCanEnter] = useState(false);
    const [isSideOpen, setIsSideOpen] = useState(true);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.scrollTop = 0;
        }
        const checkCanEnter = async () => {
            const { user, status } = await agentUserQuery.checkToken(false);

            if (status !== false) {
                setUser(user);
                setCanEnter(true);
            } else {
                // 有効なトークンが無いのでリダイレクト
                navigate('/agent/login/');
            }
        };
        checkCanEnter();
    }, [window.location]);

    return { mainRef, user, canEnter, isSideOpen, setIsSideOpen };
};
